<template>
    <div>
        <h1 class="text-3xl font-bold underline">404 Error</h1>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>